<template>
  <div class="admin-repair-detail-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('adminRepairDetail.title')" :subtitle="$t('adminRepairDetail.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="goBack">
          {{ $t('adminRepairDetail.back') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 报修信息面板 -->
    <div class="ds-panel">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('adminRepairDetail.page.infoTitle') }}</span>
      </div>

      <div class="ds-info-grid">
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminRepairDetail.repairId') }}</span>
          <span class="ds-info-grid__value ds-num">{{ adminRepairDetailInfo.repairId || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminRepairDetail.repairType') }}</span>
          <span class="ds-info-grid__value">{{ adminRepairDetailInfo.repairTypeName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminRepairDetail.repairName') }}</span>
          <span class="ds-info-grid__value">{{ adminRepairDetailInfo.repairName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminRepairDetail.tel') }}</span>
          <span class="ds-info-grid__value ds-num">{{ adminRepairDetailInfo.tel || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminRepairDetail.location') }}</span>
          <span class="ds-info-grid__value">{{ adminRepairDetailInfo.repairObjName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminRepairDetail.appointmentTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ adminRepairDetailInfo.appointmentTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminRepairDetail.status') }}</span>
          <span class="ds-info-grid__value">
            <ds-status-tag :label="adminRepairDetailInfo.stateName || '-'" :text="adminRepairDetailInfo.stateName" type="info" />
          </span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('adminRepairDetail.repairContent') }}</span>
          <span class="ds-info-grid__value">{{ adminRepairDetailInfo.context || '-' }}</span>
        </div>
      </div>
    </div>

    <!-- 图片展示部分 -->
    <div class="ds-panel" v-if="adminRepairDetailInfo.repairPhotos.length > 0">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('adminRepairDetail.repairPhotos') }}</span>
      </div>
      <div class="ds-panel__body">
        <el-row :gutter="16">
          <el-col v-for="(item, index) in adminRepairDetailInfo.repairPhotos" :key="index" :xs="8" :sm="6" :md="4">
            <el-image style="width: 120px; height: 120px;" :src="item.url" :preview-src-list="[item.url]" fit="cover" />
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 维修前图片 -->
    <div class="ds-panel" v-if="adminRepairDetailInfo.beforePhotos.length > 0">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('adminRepairDetail.beforePhotos') }}</span>
      </div>
      <div class="ds-panel__body">
        <el-row :gutter="16">
          <el-col v-for="(item, index) in adminRepairDetailInfo.beforePhotos" :key="index" :xs="8" :sm="6" :md="4">
            <el-image style="width: 120px; height: 120px;" :src="item.url" :preview-src-list="[item.url]" fit="cover" />
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 维修后图片 -->
    <div class="ds-panel" v-if="adminRepairDetailInfo.afterPhotos.length > 0">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('adminRepairDetail.afterPhotos') }}</span>
      </div>
      <div class="ds-panel__body">
        <el-row :gutter="16">
          <el-col v-for="(item, index) in adminRepairDetailInfo.afterPhotos" :key="index" :xs="8" :sm="6" :md="4">
            <el-image style="width: 120px; height: 120px;" :src="item.url" :preview-src-list="[item.url]" fit="cover" />
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 相关物品表格 -->
    <div class="ds-panel" v-if="adminRepairDetailInfo.maintenanceType === '1001' || adminRepairDetailInfo.maintenanceType === '1003'">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('adminRepairDetail.relatedItems') }}</span>
      </div>
      <ds-data-table :data="adminRepairDetailInfo.resourceStoreInfo" :density="density" border
        :empty-description="$t('adminRepairDetail.page.emptyItems')">
        <el-table-column prop="resId" :label="$t('adminRepairDetail.itemId')" align="center" width="140">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.resId || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('adminRepairDetail.itemType')" align="center" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.parentRstName }} > {{ scope.row.rstName }}
          </template>
        </el-table-column>
        <el-table-column prop="resourceStoreName" :label="$t('adminRepairDetail.itemName')" align="center" min-width="130"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.resourceStoreName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="specName" :label="$t('adminRepairDetail.itemSpec')" align="center" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.specName || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('adminRepairDetail.itemQuantity')" align="center" width="110">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.quantity }}{{ scope.row.miniUnitCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="unitPrice" :label="$t('adminRepairDetail.itemPrice')" align="center" width="110">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.unitPrice || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" :label="$t('adminRepairDetail.user')" align="center" width="110">
          <template slot-scope="scope">
            {{ scope.row.createUserName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('adminRepairDetail.time')" align="center" width="160">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.createTime || '-' }}</span>
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <!-- 工单流转表格 -->
    <div class="ds-panel">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('adminRepairDetail.workflow') }}</span>
      </div>
      <ds-data-table :data="adminRepairDetailInfo.repairUsers" :density="density" border
        :empty-description="$t('adminRepairDetail.page.emptyFlow')">
        <el-table-column type="index" :label="$t('adminRepairDetail.serial')" align="center" width="60" />
        <el-table-column prop="staffName" :label="$t('adminRepairDetail.handler')" align="center" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.staffName || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('adminRepairDetail.status')" align="center" min-width="160">
          <template slot-scope="scope">
            <ds-status-tag v-if="(scope.row.state === '10009' || scope.row.state === '12000') && scope.row.payTypeName"
              :label="`${scope.row.stateName}(${scope.row.payTypeName})`" :text="scope.row.stateName" type="info" />
            <ds-status-tag v-else :label="scope.row.stateName || '-'" :text="scope.row.stateName" type="info" />
            <el-link v-if="scope.row.state === '10007'" type="primary" @click="openRepairAppraise(scope.row)">
              {{ $t('adminRepairDetail.reply') }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="startTime" :label="$t('adminRepairDetail.startTime')" align="center" width="160">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.startTime || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="endTime" :label="$t('adminRepairDetail.endTime')" align="center" width="160">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.endTime || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="duration" :label="$t('adminRepairDetail.duration')" align="center" width="100">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.duration || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="context" :label="$t('adminRepairDetail.comment')" align="center" min-width="140"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.context || '-' }}
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <reply-repair-appraise ref="replyRepairAppraise" @success="loadRepairUser" />
  </div>
</template>

<script>
import { getRepairDetail, listRepairStaffs, listStoreUseRecords } from '@/api/work/adminRepairDetailApi'
import ReplyRepairAppraise from '@/components/work/ReplyRepairAppraise'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'AdminRepairDetail',
  components: {
    ReplyRepairAppraise,
    DsPageHeader,
    DsDataTable,
    DsStatusTag
  },
  data() {
    return {
      density: 'default',
      adminRepairDetailInfo: {
        repairId: '',
        repairType: '',
        repairTypeName: '',
        repairName: '',
        tel: '',
        roomId: '',
        roomName: '',
        repairObjName: '',
        appointmentTime: '',
        context: '',
        stateName: '',
        userId: '',
        userName: '',
        repairUsers: [],
        photos: [],
        repairPhotos: [],
        beforePhotos: [],
        afterPhotos: [],
        visitType: '',
        visitContext: '',
        maintenanceType: '',
        repairMaterials: '',
        repairFee: '',
        resourceStoreInfo: [],
        appraiseScore: 0,
        doorSpeedScore: 0,
        repairmanServiceScore: 0,
        average: 0.0
      }
    }
  },
  created() {
    const repairId = this.$route.query.repairId
    if (!repairId) {
      this.$message.error(this.$t('adminRepairDetail.invalidOperation'))
      this.$router.push('/work/repairPoolManage')
      return
    }
    this.adminRepairDetailInfo.repairId = repairId
    this.loadRepairDetail()
  },
  methods: {
    async loadRepairDetail() {
      try {
        const params = {
          page: 1,
          row: 1,
          repairId: this.adminRepairDetailInfo.repairId
        }
        const { data } = await getRepairDetail(params)
        if (data.length < 1) {
          this.$message.error(this.$t('adminRepairDetail.dataError'))
          this.$router.push('/work/repairPoolManage')
          return
        }
        this.adminRepairDetailInfo = { ...this.adminRepairDetailInfo, ...data[0] }

        if (this.adminRepairDetailInfo.maintenanceType === '1001' || this.adminRepairDetailInfo.maintenanceType === '1003') {
          this.loadResourceStoreList()
        }
        this.loadRepairUser()
      } catch (error) {
        this.$message.error(error.message || this.$t('adminRepairDetail.loadError'))
      }
    },
    async loadResourceStoreList() {
      try {
        const params = {
          page: 1,
          row: 100,
          repairId: this.adminRepairDetailInfo.repairId
        }
        const { data } = await listStoreUseRecords(params)
        this.adminRepairDetailInfo.resourceStoreInfo = data.map(item => {
          if (item.resId === '666666') {
            return { ...item, rstName: '自定义', specName: '自定义' }
          }
          return item
        })
      } catch (error) {
        this.$message.error(error.message || this.$t('adminRepairDetail.loadResourceError'))
      }
    },
    async loadRepairUser() {
      try {
        const params = {
          page: 1,
          row: 100,
          repairId: this.adminRepairDetailInfo.repairId
        }
        const { data } = await listRepairStaffs(params)
        this.adminRepairDetailInfo.repairUsers = data
      } catch (error) {
        this.$message.error(error.message || this.$t('adminRepairDetail.loadUserError'))
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    openRepairAppraise(row) {
      this.$refs.replyRepairAppraise.open(row)
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-repair-detail-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-md);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--ds-spacing-sm) var(--ds-spacing-lg);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }

  &__body {
    padding: var(--ds-spacing-lg);
  }
}

/* 信息栅格 */
.ds-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--ds-spacing-md) var(--ds-spacing-lg);
  padding: var(--ds-spacing-lg);

  &__item {
    display: flex;
    align-items: baseline;
    gap: var(--ds-spacing-sm);
    min-width: 0;
  }

  &__label {
    flex-shrink: 0;
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-500);
  }

  &__value {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-900);
    word-break: break-all;
  }
}
</style>
